/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */
import {Component, ElementRef, Input} from "@angular/core";
import {ControlValueAccessor} from "@angular/forms";

@Component({
    selector: 'ui-spinner',
    template: require('./ui-spinner.html'),
    styles: [require('./ui-spinner.less')],
})
export class UiSpinner {
    @Input() public show: boolean;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-spinner/ui-spinner.ts